// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueWechatTitle from 'vue-wechat-title'
import axios from 'axios'
import echarts from 'echarts'
import common from './common/unit'
import store from './store/index'
import JsonViewer from 'vue-json-viewer'
let Base64 = require('js-base64').Base64

Vue.use(VueWechatTitle)
Vue.use(ElementUI)
Vue.use(echarts)
Vue.use(common)
Vue.use(Vuex)
Vue.use(Base64)
Vue.use(JsonViewer)

// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  })
// http response 拦截器
axios.interceptors.response.use(
  response => {
    // console.log('response====' + JSON.stringify(response))
    return response
  },
  error => {
    // console.log('error======' + JSON.stringify(error))
    if (error.response) {
      // console.log('error=' + JSON.stringify(error.response))
      switch (error.response.status) {
        case 401:
          // 返回 401 清除token信息并跳转到登录页面
          localStorage.removeItem('Authorization')
          localStorage.removeItem('UserInfo')
          router.replace('/login')
          // this.$router.push({ path: '/login' })
          break
      }
      if (error.response.data.message === 'token过期') {
        localStorage.removeItem('Authorization')
        localStorage.removeItem('UserInfo')
        // this.$router.push({ path: '/login' })
        router.replace('/login')
        return false
      };
    }
    return Promise.reject(error.response.data) // 返回接口返回的错误信息
  })

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
Vue.prototype.$common = common
Vue.prototype.$store = store

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js